import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  card1: {
    marginBottom: 20,
    paddingBottom: 25,
  },
  cardHeader: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      display: 'flex',
      alignItems: 'flex-start',
    },
  },
  cardHeaderButton: {
    [theme.breakpoints.down('sm')]: {
      marginRight: 'auto',
      marginTop: theme.spacing(2),
    },
  },
}));